import { Routes } from '@angular/router';
import { SERVICOS_RELATORIOS_ROUTES, SERVICOS_ROUTES } from '@/features/servicos/servicos.constants';

/**
 * Rotas de Relatórios do módulo de Serviços.
 *
 * <p>Espalhado nos `children` de `/servicos/:tipo` (ver `servicos.routes.ts`), NUNCA como rota irmã:
 * é o que faz herdar o `servicosVisualizarGuard` do pai — que já valida a role conforme o `:tipo` —
 * e o que mantém cada setor dentro dos próprios relatórios. Rota irmã exigiria inventar permissão
 * nova e abriria a porta para um relatório de PF ser aberto por quem só tem PJ.</p>
 *
 * <p>Cada relatório entra como filha daqui, com o `routerLink` correspondente em
 * `servicos-relatorios-content.ts`. Os dois lados leem os mesmos segmentos de
 * {@link SERVICOS_RELATORIOS_ROUTES}: um sem o outro devolve card apontando para rota inexistente.</p>
 */
export const servicosRelatorioRoutes: Routes = [
    {
        path: SERVICOS_ROUTES.RELATORIOS,
        loadComponent: () => import('@/features/servicos/relatorios/servicos-relatorios-content').then((m) => m.ServicosRelatoriosContent),
        data: { breadcrumb: 'Relatórios' },
        children: [
            {
                path: SERVICOS_RELATORIOS_ROUTES.ENTRADA_SAIDA,
                loadComponent: () => import('@/features/servicos/relatorios/components/entrada-saida/entrada-saida').then((m) => m.RelatorioEntradaSaida),
                data: { breadcrumb: 'Entrada × Saída' }
            },
            {
                path: SERVICOS_RELATORIOS_ROUTES.CARGA,
                loadComponent: () => import('@/features/servicos/relatorios/components/carga/carga').then((m) => m.RelatorioCarga),
                data: { breadcrumb: 'Carga por Analista' }
            },
            {
                path: SERVICOS_RELATORIOS_ROUTES.DESFECHO,
                loadComponent: () => import('@/features/servicos/relatorios/components/desfecho/desfecho').then((m) => m.RelatorioDesfecho),
                data: { breadcrumb: 'Desfecho das Conclusões' }
            },
            {
                path: SERVICOS_RELATORIOS_ROUTES.ADOCAO,
                loadComponent: () => import('@/features/servicos/relatorios/components/adocao/adocao').then((m) => m.RelatorioAdocao),
                data: { breadcrumb: 'Adoção do Quadro' }
            },
            {
                path: SERVICOS_RELATORIOS_ROUTES.TEMPO_DE_CICLO,
                loadComponent: () => import('@/features/servicos/relatorios/components/tempo-de-ciclo/tempo-de-ciclo').then((m) => m.RelatorioTempoDeCiclo),
                data: { breadcrumb: 'Tempo de Ciclo' }
            },
            {
                path: SERVICOS_RELATORIOS_ROUTES.RETRABALHO,
                loadComponent: () => import('@/features/servicos/relatorios/components/retrabalho/retrabalho').then((m) => m.QuadroRetrabalho),
                data: { breadcrumb: 'Retrabalho' }
            },
            {
                path: SERVICOS_RELATORIOS_ROUTES.ENVELHECIMENTO,
                loadComponent: () => import('@/features/servicos/relatorios/components/envelhecimento/envelhecimento').then((m) => m.RelatorioEnvelhecimento),
                data: { breadcrumb: 'Envelhecimento' }
            }
        ]
    }
];
